import styled from 'styled-components'

export const SearchBarWrap = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
  margin-bottom: 16px;
`

export const SearchBarIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: var(--stroke);
`

export const SearchBarTitle = styled.div`
  font-size: 14px;
  line-height: 1.2em;
  font-weight: 600;
  color: var(--tertiary);
`

export const SearchBarBox = styled.div`
  padding-left: 36px;
`
export const AdsChip = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  padding-right: 4px;
  padding-left: 32px;
  transition: border-color 0.26s ease-in-out;
  border: 1px solid var(--purple);
  border-radius: 16px;
  height: 32px;
  cursor: pointer;
`

export const SearchBarLabel = styled.div`
  padding: 2px 8px;
  font-size: 12px;
  line-height: 1.3em;
  font-weight: 600;
  border: 1px solid var(--stroke);
  border-radius: 4px;
  background-color: var(--white);
  box-shadow: 0px 392px 110px 0px rgba(27, 27, 68, 0),
    0px 251px 100px 0px rgba(27, 27, 68, 0),
    0px 141px 85px 0px rgba(27, 27, 68, 0.01),
    0px 63px 63px 0px rgba(27, 27, 68, 0.02),
    0px 16px 35px 0px rgba(27, 27, 68, 0.02),
    0px 0px 0px 0px rgba(27, 27, 68, 0.02);
`
